import { render, staticRenderFns } from "./Signups.vue?vue&type=template&id=d1d8fef2&"
import script from "./Signups.vue?vue&type=script&lang=ts&"
export * from "./Signups.vue?vue&type=script&lang=ts&"
import style0 from "./Signups.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports